export default __webpack_public_path__ + "static/avatar-kayi-common-8-aa26adc6795bf5c11350e8fafb7ff549.png";